export class AssetsFilter  {

    readonly ASSETS_LESS: string = "[* TO 100000]";
    readonly ASSETS_TO_500000: string = "[100001 TO 500000]";
    readonly ASSETS_TO_1000000: string = "[500001 TO 1000000]";
    readonly ASSETS_TO_10000000: string = "[1000001 TO 10000000]";
    readonly ASSETS_TO_More: string = "[10000001 TO *]";


}